import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import AddEditAuction from "../pages/AuctionManagement/AddEditAuction";
import AuctionManagement from "../pages/AuctionManagement/List";
import BidPackageManagement from "../pages/BidPackageManagement";
import ViewAuction from "../pages/AuctionManagement/ViewAuction";
import AddEditBidPackageManagement from "../pages/BidPackageManagement/AddEdit";
import ViewBidPackage from "../pages/BidPackageManagement/view";
import Category from "../pages/Category";
import AddEditCategory from "../pages/Category/AddEdit";
import AddEditSubCategory from "../pages/Category/AddEditSubCategory";
import CategoryView from "../pages/Category/view";
import AddEditFaq from "../pages/faq/Edit";
import FaqList from "../pages/faq/List";
import AddEditEmailTemplate from "../pages/EmailTemplate/AddEditEmailTemplate";
import EmailTemplateList from "../pages/EmailTemplate/List";
import ViewEmailDetail from "../pages/EmailTemplate/ViewEmail";
import GlobalSetting from "../pages/Global Setting";
import AddEditUserManagement from "../pages/UserManagement/AddEditUser";
import UserManagementList from "../pages/UserManagement/List";
import ViewUserManagement from "../pages/UserManagement/ViewUser";
import AddEditVehicle from "../pages/VehicleManagement/AddEditVehicle";
import VehicleManagementList from "../pages/VehicleManagement/List";
import ViewVehicle from "../pages/VehicleManagement/ViewVehicle";
import AddEditSubAdminManagement from "../pages/subadminManagement/addEditSubadmin";
import SubAdminManagementList from "../pages/subadminManagement/List";
import CustomerSupportList from "../pages/CustomerSupport/List";
import ViewCustomerSupport from "../pages/CustomerSupport/View";
import ChatSupport from "../pages/CustomerSupport/ChatSupport";
import FeedbackManagementList from "../pages/FeedbackManagement/List";
import PlaceBids from "../pages/AirdropManagement/PlaceBids";
import AuctionEarnBids from "../pages/AirdropManagement/AuctionEarnBids";
import ShareOnSocialMedia from "../pages/AirdropManagement/ShareOnSocialMedia";
import AuctionList from "../pages/AuctionManagement/BiddingControl/List";
import TicketList from "../pages/AuctionManagement/BiddingControl/TicketList";
import BidNow from "../pages/AuctionManagement/BiddingControl/BiddingView";
import TicketQuantity from "../pages/AuctionManagement/BiddingControl/ticketQuantity";
import BiddingHistory from "../pages/AuctionManagement/BiddingControl/BiddingHistory";
import ViewSubLastCategory from "../pages/Category/ViewSubLastCategory";
import AboutUs from "../pages/cms/AboutUs";
import PaymentTransactions from "../pages/PaymentManagement/PaymentList";
import ReffrealList from "../pages/UserManagement/ReffrealList";
import { Loader } from "../components/CustomLoader";
import ThemePreview from "../components/ThemePreview";
import AddbannerOffer from "../pages/BannerManagement/Add";
import Offerandbannermanagement from "../pages/BannerManagement/List";
import OfferAndBannerView from "../pages/BannerManagement/View";
import MakesManagement from "../pages/MakesManagement";
import AddEditMakes from "../pages/MakesManagement/AddEdit";
import ViewMake from "../pages/MakesManagement/View";
import BidControlManagement from "../pages/BidControlManagement/index";
import ViewBidControl from "../pages/BidControlManagement/View";
import OrdermanagementList from "../pages/orderManagement/List"
import OrdermanagementDetail from "../pages/orderManagement/Detail"
import NotificationTemplateList from "../pages/Notificationmanagement/List";
import NotificationTemplateView from "../pages/Notificationmanagement/View";
import NotificationTemplateForm from "../pages/Notificationmanagement/AddEdit";
import ReportsAndAnalytics from "../pages/ReportsAndAnalytics";

const ChangePassword = lazy(() => import("../pages/auth/ChangePassword"));

//CMS............................................................ ............................
const CmsPage = lazy(() => import("../pages/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/cms/AddEditCms"));

// Social Media Management
const SocialMediaList = lazy(() => import("../pages/SocialMediaManagement/List"));
const AddEditSocialMedia = lazy(() => import("../pages/SocialMediaManagement/Add"));

//MyAccount........................................................................................
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));

const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadingFallback = <div><Loader /></div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = ({ permissions }) => {

  let dataparmition = permissions?.permissions || {};

  let data = Object.keys(dataparmition);
  const hasPermission = (permissionKey) => {
    return dataparmition && data.includes(permissionKey);
  };


  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        {
          path: "dashboard",
          element: makeLazyComponent(() => <DashboardPage />),
        },
        {
          path: "theme-preview",
          element: <ThemePreview />,
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: makeLazyComponent(() => <GlobalSetting />),
        },

        ...(hasPermission("Reports & Analytics Management")
          ? [
            {
              path: "reports-and-analytics",
              element: makeLazyComponent(() => <ReportsAndAnalytics />),
            },
          ]
          : []),

        ...(hasPermission("User Management")
          ? [
            {
              path: "user-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <UserManagementList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditUserManagement />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditUserManagement />),
                },
                {
                  path: "refer-list/:id",
                  element: makeLazyComponent(() => <ReffrealList />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewUserManagement />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Vehicle Management")
          ? [
            {
              path: "vehicle-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <VehicleManagementList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditVehicle />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditVehicle />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewVehicle />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Event Management")
          ? [
            {
              path: "event-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <AuctionManagement />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditAuction />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditAuction />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewAuction />),
                },
              ],
            },
            {
              path: "bidding-control",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <AuctionList />),
                },
                {
                  path: "bidnow/:id/:auctionId",
                  element: makeLazyComponent(() => <BidNow />),
                },
                {
                  path: "ticket-quantity/:id/:auctionId/:startDate",
                  element: makeLazyComponent(() => <TicketQuantity />),
                },
                {
                  path: "bidding-history/:id/:auctionId/:roomId",
                  element: makeLazyComponent(() => <BiddingHistory />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <TicketList />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Bid Package Management")
          ? [
            {
              path: "bid-package-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <BidPackageManagement />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => (<AddEditBidPackageManagement />)),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => (<AddEditBidPackageManagement />)),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewBidPackage />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Bid Controller Management")
          ? [
            {
              path: "bid-controller-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <BidControlManagement />),
                },
                {
                  path: "auction",
                  element: makeLazyComponent(() => <BidControlManagement />),
                },
                {
                  path: "market-dropai",
                  element: makeLazyComponent(() => <BidControlManagement />),
                },
                {
                  path: "claimpoint",
                  element: makeLazyComponent(() => <BidControlManagement />),
                },
                {
                  path: "view/:id/:type",
                  element: makeLazyComponent(() => <ViewBidControl />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Category Management")
          ? [
            {
              path: "category",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <Category />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditCategory />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditCategory />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <CategoryView />),
                },
                {
                  path: "add-subcategory/:categoryid",
                  element: makeLazyComponent(() => <AddEditSubCategory />),
                },
                {
                  path: "edit-subcategory/:id",
                  element: makeLazyComponent(() => <AddEditSubCategory />),
                },
                {
                  path: "viewsubcategory/:id",
                  element: makeLazyComponent(() => <ViewSubLastCategory />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Subadmin Management")
          ? [
            {
              path: "subadmin-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => (<SubAdminManagementList />)),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => (<AddEditSubAdminManagement />)),
                },

                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => (
                    <AddEditSubAdminManagement />
                  )),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Vehicle Make Management")
          ? [
            {
              path: "vehicle-makes-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => (<MakesManagement />)),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => (<AddEditMakes />)),
                },

                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => (<AddEditMakes />)),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => (<ViewMake />)),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Banner Management")
          ? [
            {
              path: "banner-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => (<Offerandbannermanagement />)),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => (<AddbannerOffer />)),
                },

                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => (<AddbannerOffer />)),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => (<OfferAndBannerView />)),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Banner Management")
          ? [
            {
              path: "ordermanagement",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => (<OrdermanagementList />)),
                },
                {
                  path: "detail/:id",
                  element: makeLazyComponent(() => (<OrdermanagementDetail />)),
                },

                // {
                //   path: "edit/:id",
                //   element: makeLazyComponent(() => ( <AddbannerOffer /> )),
                // },
                // {
                //   path: "view/:id",
                //   element: makeLazyComponent(() => ( <OfferAndBannerView /> )),
                // },
              ],
            },
          ]
          : []),

        ...(hasPermission("Email Template Management")
          ? [
            {
              path: "email-template-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <EmailTemplateList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditEmailTemplate />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditEmailTemplate />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewEmailDetail />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Airdrop Management")
          ? [
            {
              path: "airdrop-management",
              children: [
                {
                  path: "placebids",
                  element: makeLazyComponent(() => <PlaceBids />),
                },
                {
                  path: "share-on-social-Media",
                  element: makeLazyComponent(() => <ShareOnSocialMedia />),
                },
                {
                  path: "auction-to-earn-bids",
                  element: makeLazyComponent(() => <AuctionEarnBids />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Content Management")
          ? [
            {
              path: "cms",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <CmsPage />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditCms />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditCms />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewCms />),
                },
              ],
            },
            {
              path: "about-us",
              element: makeLazyComponent(() => <AboutUs />),
            },
          ]
          : []),

        ...(hasPermission("FAQ Management")
          ? [
            {
              path: "faq",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <FaqList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditFaq />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditFaq />),
                },
              ],
            },
          ]
          : []),
        ...(hasPermission("Customer Support Management")
          ? [
            {
              path: "customer-support",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <CustomerSupportList />),
                },
                {
                  path: "chat",
                  element: makeLazyComponent(() => <ChatSupport />),
                },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <ViewCustomerSupport />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Feedback Management")
          ? [
            {
              path: "feedback-management",
              children: [
                {
                  index: true, element: makeLazyComponent(() => <FeedbackManagementList />),
                },
              ],
            },
          ]
          : []),

        ...(hasPermission("Notification management")
          ? [
            {
              path: "notification-management",
              children: [
                { index: true, element: makeLazyComponent(() => <NotificationTemplateList />) },
                {
                  path: "view/:id",
                  element: makeLazyComponent(() => <NotificationTemplateView />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <NotificationTemplateForm />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <NotificationTemplateForm />),
                },
              ]
            },

          ]
          : []),

        ...(hasPermission("Payment Management")
          ? [
            {
              path: "payment-management",
              children: [
                { index: true, element: makeLazyComponent(() => <PaymentTransactions />) },
              ]
            },
          ]
          : []),

        ...(true // hasPermission("Social Media Management")
          ? [
            {
              path: "social-media-management",
              children: [
                {
                  index: true,
                  element: makeLazyComponent(() => <SocialMediaList />),
                },
                {
                  path: "add",
                  element: makeLazyComponent(() => <AddEditSocialMedia />),
                },
                {
                  path: "edit/:id",
                  element: makeLazyComponent(() => <AddEditSocialMedia />),
                },
              ],
            },
          ]
          : []),




      ],
    },
    { path: "*", element: <Navigate to="/dashboard" /> },
  ];

  return useRoutes(routes);
};

export default MainRouting;
